import { useState, useRef, useCallback } from 'react';

interface UseHoverFlyoutReturn {
  isHovered: boolean;
  flyoutTop: number;
  elementRef: React.RefObject<HTMLDivElement | null>;
  handleMouseEnter: () => void;
  handleMouseLeave: () => void;
  closeFlyout: () => void;
  hoverProps: {
    ref: React.RefObject<HTMLDivElement | null>;
    onMouseEnter: () => void;
    onMouseLeave: () => void;
  };
}

const useHoverFlyout = (): UseHoverFlyoutReturn => {
  const [isHovered, setIsHovered] = useState(false);
  const [flyoutTop, setFlyoutTop] = useState(0);
  const elementRef = useRef<HTMLDivElement>(null);

  const handleMouseEnter = useCallback(() => {
    if (elementRef.current) {
      const rect = elementRef.current.getBoundingClientRect();

      setFlyoutTop(rect.top);
    }

    setIsHovered(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setIsHovered(false);
  }, []);

  const closeFlyout = useCallback(() => {
    setIsHovered(false);
  }, []);

  return {
    isHovered,
    flyoutTop,
    elementRef,
    handleMouseEnter,
    handleMouseLeave,
    closeFlyout,
    hoverProps: {
      ref: elementRef,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
    },
  };
};

export default useHoverFlyout;
